import * as Sentry from '@sentry/react';

const APP_NAME = 'Connect';

const resolveErrorMessage = (error: unknown, zone: string): string => {
  if (typeof error === 'string') return error;

  const message = (error as { message?: unknown })?.message;

  if (typeof message === 'string' && message) return message;

  return `Auth error: ${zone}`;
};

export const captureAuthError = (zone: string, error: unknown, extra?: Record<string, unknown>) => {
  const normalizedError =
    error instanceof Error ? error : new Error(resolveErrorMessage(error, zone));

  Sentry.captureException(normalizedError, {
    tags: { app: APP_NAME, zone: `${APP_NAME} - ${zone}` },
    extra: { ...extra, originalError: error }
  });
};

export interface SentryUserDto {
  id: string | null;
  email: string;
}

export interface StockExceededConfirmContext {
  caseId: number | null;
  partName: string | null;
  partCode: string | null;
  alternativePartCode: string | null;
  selectedQuantity: number;
  availableStock: number | null;
}

export const captureStockExceededConfirm = (
  user: SentryUserDto | null,
  context: StockExceededConfirmContext
) => {
  const occurredAt = new Date();
  const part = `${context.partName ?? ''} [${context.partCode ?? ''}]`.trim();
  const message =
    `Confirmare depasire stoc acceptata — dosar ${context.caseId ?? '—'} — ${part}`;

  // Structured log so each confirmation is a separate, filterable entry in Sentry Logs.
  Sentry.logger.info(message, {
    app: APP_NAME,
    zone: `${APP_NAME} - Alternative Calculation`,
    caseId: context.caseId ?? undefined,
    part,
    partName: context.partName ?? undefined,
    partCode: context.partCode ?? undefined,
    alternativePartCode: context.alternativePartCode ?? undefined,
    selectedQuantity: context.selectedQuantity,
    availableStock: context.availableStock ?? undefined,
    userId: user?.id ?? undefined,
    email: user?.email ?? undefined,
    occurredAt: occurredAt.toISOString(),
    occurredAtLocal: occurredAt.toLocaleString()
  });
};
